var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommutersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(0 -0.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 27,
    height: 27,
    transform: "translate(0 0.075)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group_1_",
    "data-name": "group (1)",
    transform: "translate(1.659 3.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(18.737 11.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M400.356,273.32h-1.862a4.842,4.842,0,0,1,.293,1.665v7.036a2.075,2.075,0,0,1-.12.7h3.078a2.087,2.087,0,0,0,2.085-2.085V276.8A3.479,3.479,0,0,0,400.356,273.32Z",
    transform: "translate(-398.494 -273.32)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(0 11.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M5.043,274.986a4.843,4.843,0,0,1,.293-1.665H3.475A3.479,3.479,0,0,0,0,276.8v3.836a2.087,2.087,0,0,0,2.085,2.085H5.163a2.076,2.076,0,0,1-.12-.7Z",
    transform: "translate(0 -273.321)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(6.433 9.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M144.56,234.815H140.3a3.479,3.479,0,0,0-3.475,3.475v7.036a.7.7,0,0,0,.7.7h9.816a.7.7,0,0,0,.7-.7V238.29A3.479,3.479,0,0,0,144.56,234.815Z",
    transform: "translate(-136.829 -234.815)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(7.857 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M171.293,38.84a4.179,4.179,0,1,0,4.179,4.179A4.184,4.184,0,0,0,171.293,38.84Z",
    transform: "translate(-167.114 -38.84)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(1.572 3.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M36.569,121.689a3.124,3.124,0,1,0,3.126,3.126A3.129,3.129,0,0,0,36.569,121.689Z",
    transform: "translate(-33.443 -121.689)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(16.25 3.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M348.733,121.689a3.126,3.126,0,1,0,3.126,3.126A3.129,3.129,0,0,0,348.733,121.689Z",
    transform: "translate(-345.607 -121.689)",
    fill: "#a4a4a4"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommutersIcon);
export default __webpack_public_path__ + "static/media/commuters-icon.257d0486c34f7ef9f85656b0bc4659f1.svg";
export { ForwardRef as ReactComponent };